import { Breadcrumb } from "antd";
import { useBreadcrumb } from "../../store/context/BreadcrumbContext";
import { Link } from "react-router-dom";

const CustomBreadcrumb = () => {
  const { items } = useBreadcrumb();

  function itemRender(route, params, routes, paths) {
    const isLast = routes.indexOf(route) === routes.length - 1;

    return isLast ? (
      <span style={{ color: "#000" }}>{route.title}</span>
    ) : (
      <Link to={route?.path}>{route.title}</Link>
    );
  }

  return <Breadcrumb itemRender={itemRender} items={items} />;
};

export default CustomBreadcrumb;
